import React from "react";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

function WidgetItemInternal(props) {
  let langCode = "en";
  if (props.activeLanguage !== undefined) {
    langCode = props.activeLanguage.code;
  }

  return (
    <div class="col-12  col-sm-12 col-md-3">
      <Link to={props.link}>
        <div
          class="card"
 
        >
          <img
            class="card-img-top"
            src={`../assets/img/widgets/${props.logo}`}
            alt={props.name_en}
            height="200"
          />
          <div class="card-block">
            <h5 class="card-title text-center">
              {langCode == "ar" ? props.name_ar : props.name_en}
            </h5>
            {/* <p class="card-text">{props.text_en}</p> */}
          </div>
        </div>
      </Link>
    </div>
  );
}
export default withLocalize(WidgetItemInternal);



// WEBPACK FOOTER //
// ./src/pages/Home/WidgetItemInternal.js